import { render, staticRenderFns } from "./AttachCommunication.vue?vue&type=template&id=be0f6bec&lang=pug"
import script from "./AttachCommunication.vue?vue&type=script&lang=js"
export * from "./AttachCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports